var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManpowerExpenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 28.466 32.268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8158",
    "data-name": "Group 8158",
    transform: "translate(-29.926 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24875",
    "data-name": "Path 24875",
    d: "M100.417,226.988a.938.938,0,0,0-.938-.938H91.911a.938.938,0,0,0,0,1.876h7.568A.938.938,0,0,0,100.417,226.988Z",
    transform: "translate(-57.135 -211.912)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24876",
    "data-name": "Path 24876",
    d: "M95.619,286.05H91.86a.938.938,0,0,0,0,1.876h3.759a.938.938,0,1,0,0-1.876Z",
    transform: "translate(-57.087 -268.16)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24878",
    "data-name": "Path 24878",
    d: "M137.309,81.062h1.851v1.851a.938.938,0,0,0,1.876,0V81.062h1.851a.938.938,0,1,0,0-1.876h-1.851V77.334a.938.938,0,1,0-1.876,0v1.851h-1.851a.938.938,0,1,0,0,1.876Z",
    transform: "translate(-99.694 -71.618)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24879",
    "data-name": "Path 24879",
    d: "M50.718,15.18V13.2H57.35a.938.938,0,0,0,.938-.938V4.723A4.729,4.729,0,0,0,53.563,0H34.716a4.7,4.7,0,0,0-4.69,4.69V31.066a.939.939,0,0,0,1.616.649l1.2-1.253L34.11,31.73a.938.938,0,0,0,1.327,0l1.2-1.2,1.214,1.2a.938.938,0,0,0,1.321,0l1.233-1.222,1.233,1.222a.938.938,0,0,0,1.321,0l1.594-1.582a8.442,8.442,0,1,0,6.164-14.97ZM56.412,4.723v6.6H50.718v-6.6a2.847,2.847,0,1,1,5.694,0ZM42.3,29.745l-1.233-1.222a.938.938,0,0,0-1.321,0l-1.233,1.222L37.3,28.539a.938.938,0,0,0-1.324,0l-1.2,1.2-1.282-1.283a.937.937,0,0,0-1.341.015l-.247.258V4.69a2.817,2.817,0,0,1,2.813-2.813H49.8a4.7,4.7,0,0,0-.958,2.847V15.2a8.438,8.438,0,0,0-5.609,13.623Zm7.55.4a6.567,6.567,0,1,1,6.567-6.567A6.574,6.574,0,0,1,49.849,30.145Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000127736869356276977400000010254600488177106082_",
    transform: "translate(-25.335 19.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rupee",
    transform: "translate(71.7 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24870",
    "data-name": "Path 24870",
    d: "M75.388,8.439a.56.56,0,0,1-.411-.179L71.85,4.891a.56.56,0,0,1,.41-.942h1.547a1.365,1.365,0,0,0,1.245-.8H72.778a.56.56,0,0,1,0-1.121h2.272a1.365,1.365,0,0,0-1.243-.8H72.26A.56.56,0,0,1,72.26.1h4.882a.56.56,0,1,1,0,1.121H75.885a2.441,2.441,0,0,1,.344.8h.915a.56.56,0,0,1,0,1.121H76.23a2.491,2.491,0,0,1-2.422,1.927h-.261L75.8,7.5a.561.561,0,0,1-.029.792A.572.572,0,0,1,75.388,8.439Z",
    transform: "translate(-71.7 -0.1)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManpowerExpenses);
export default __webpack_public_path__ + "static/media/ManpowerExpenses.a2f77b45add5b69a58560275012b225c.svg";
export { ForwardRef as ReactComponent };